import { Tag } from 'antd';
import DashboardCard from 'components/DashboardCard';
import React from 'react';
import { FormattedRelativeTime } from 'react-intl';
import { dayjs } from 'shared/utils/date';
import selectUnit from 'shared/utils/selectUnit';

function getStats(heatmap) {
  if (heatmap) {
    return [
      {
        title: 'Sample rate',
        value: heatmap.sampleRate,
        suffix: '%',
      },
      { title: 'Samples', value: heatmap.samples[0] },
      {
        title: 'Last sample',
        value: heatmap.lastSample && dayjs(heatmap.lastSample).toDate(),
        formatter: time => (time ? <FormattedRelativeTime {...selectUnit(time)} /> : '-'),
      },
    ];
  }

  return [];
}

const HeatmapCard = ({ dataSourceId, heatmap, canEdit }) => {
  const websiteStats = getStats(heatmap);

  return (
    <DashboardCard
      title={heatmap.name}
      extra={[<Tag>Heatmap</Tag>]}
      period="Last 30 days"
      statistics={websiteStats}
      resultsUrl={`/data-sources/${dataSourceId}/hsr/heatmaps/${heatmap.matomoHsrId}`}
      manageUrl={canEdit && `/data-sources/${dataSourceId}/hsr/manage-heatmaps`}
    />
  );
};

export default HeatmapCard;
